import script from "./TranscriptViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./TranscriptViewer.vue?vue&type=script&setup=true&lang=ts"

import "./TranscriptViewer.vue?vue&type=style&index=0&id=f3f426e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3f426e6"]])

export default __exports__